import {PolicyScheduleState, PolicyScheduleStore} from './policy-schedule.store';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from '../../shared/state/signal-entity.store';
import {PolicyScheduleMain} from '../../shared/models/policy.model';

@Injectable({providedIn: 'root'})
export class PolicyScheduleQuery extends SignalEntityQuery<PolicyScheduleMain, PolicyScheduleState> {

  selectSummaryList$ = this.select('distinctSummaryList');
  selectDatasetNineHeaders$ = this.select('distinctDatasetNineList');

  constructor(protected store: PolicyScheduleStore) {
    super(store);
  }

  getDetailsSection(): Observable<any[]> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.index === 3).length > 0 ||
          item.schedule.filter(val => val.index === 4 ).length > 0 ||
          item.schedule.filter(val => val.index === 5 ).length > 0 ||
          item.schedule.filter(val => val.index === 2 ).length > 0 ||
          item.schedule.filter(val => val.index === 1 ).length > 0
      ]
    });
  }

  getClassInsurers(): Observable<any> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.index === 6).length > 0
      ]
    });
  }

  getWording(): Observable<any[]> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.header === 'Policy Wording').length > 0
      ]
    });
  }

  getPolicyNotes(): Observable<any[]> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.header === 'Policy Notes').length > 0
      ]
    });
  }

  getSummaryItem(): Observable<any> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.index === 6).length > 0
      ]
    });
  }

  // "Class Wording"/"Item Wording" (used to live under index 9's now-dead #class_details)
  // were consolidated into index 8's unified wording set (T-084) alongside Policy Wording;
  // component.ts already filters this by header==='Class Wording'/'Item Wording' + class_name.
  // Vaps Wording (Benefit Conditions) was split back out to its own index=9 (T-084, 20260821)
  // -- see getBenefitConditions() -- so it's no longer part of this result set.
  getDatasetNineClassWording(): Observable<any[]> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.index === 8).length > 0
      ]
    });
  }

  // Benefit Conditions (Vaps Wording, product_vaps_type_id = 1 only) -- its own result set as
  // of T-084 (20260821), no longer filtered out of index 8's unified wording.
  getBenefitConditions(): Observable<any[]> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.index === 9).length > 0
      ]
    });
  }

  getDatasetTenBenefits(): Observable<any[]> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.index === 10).length > 0
      ]
    });
  }

  getDisclosureNotice(): Observable<any[]> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.index === 11).length > 0
      ]
    });
  }

  getSignature(): Observable<any[]> {
    return this.selectAll({
      filterBy: [
        item => item.schedule.filter(val => val.index === 12).length > 0
      ]
    });
  }
}
